import infosShopCard from "./infosShopCard"
export default infosShopCard;
